import Alert from '../../../../common/components/alerts/Alert';
import {useI18n} from '../../../../common/providers/I18nProvider';
import {routes} from '../../../../routing/routes';
import GoogleButton from '../../common/components/GoogleButton';
import PasswordField from '../../common/components/PasswordField';
import SecondaryLink from '../../common/components/SecondaryLink';
import SubmitButton from '../../common/components/SubmitButton';
import useLoginWithGoogleToken from '../../common/hooks/useLoginWithGoogleToken';
import useLogin from './hooks/useLogin';
import Form from '../../common/components/Form';
import FormControl from '../../common/components/FormControl';
import EmailField from '../../common/components/EmailField';
import RightAlignedLink from '../../common/components/RightAlignedLink';

export default function Login() {
	const {i18n} = useI18n();
	const {loading, formik, canNotSubmit, isEmailInvalid, isPasswordInvalid, alert} = useLogin();
	const {googleLoginButtonHandler, isLoading} = useLoginWithGoogleToken();

	return (
		<Form status={formik.status} handleSubmit={formik.handleSubmit} title='AUTH.LOGIN.TITLE'>
			{alert && (
				<Alert
					{...alert}
					message={i18n('AUTH.RESET.SUCCESS.ALERT.MESSAGE')}
					title={i18n('AUTH.RESET.SUCCESS.ALERT.TITLE')}
					extraClasses='mb-4'
				/>
			)}

			<FormControl label='AUTH.LOGIN.FIELD.EMAIL.LABEL' isInvalid={isEmailInvalid} error={formik.errors.email}>
				<EmailField
					fieldProps={formik.getFieldProps('email')}
					isInvalid={isEmailInvalid}
					placeholder='AUTH.LOGIN.FIELD.EMAIL.PLACEHOLDER'
				/>
			</FormControl>

			<FormControl label='AUTH.LOGIN.FIELD.PASSWORD.LABEL' isInvalid={isPasswordInvalid} error={formik.errors.password}>
				<PasswordField fieldProps={formik.getFieldProps('password')} error={isPasswordInvalid} />
			</FormControl>

			<RightAlignedLink title='AUTH.LOGIN.BUTTON.FORGOT' route={routes.forgot} />

			<SubmitButton canNotSubmit={canNotSubmit} loading={loading}>
				{i18n('AUTH.LOGIN.BUTTON.LOGIN')}
			</SubmitButton>

			<GoogleButton
				text={i18n('AUTH.LOGIN.BUTTON.GOOGLE')}
				buttonHandler={() => googleLoginButtonHandler()}
				loading={isLoading}
			/>

			<SecondaryLink to={routes.register}>{i18n('AUTH.LOGIN.BUTTON.REGISTRATION')}</SecondaryLink>
		</Form>
	);
}
